<template>
    <el-container>
        <el-header>
            <el-form style="width:100%;padding-top: 10px;">
                <el-row type="flex"  justify="space-between" >
                      <query-gather :is-add="true" :is-input="true" :is-query="true" :is-reset="true"
                                    :cur-input-tip="curInputTip"
                                    @qgAddDeal="setRole(false,'新增角色')" @qgDelAllDeal="handleAllDelete" @qgQueryDeal="getJsxxPage_"
                                    @qgResetDeal="chongzhi"
                      ></query-gather>
                </el-row>
            </el-form>
        </el-header>
        <el-main style="padding-left: 15px;padding-right:15px;padding-bottom: 10px;">
          <div style="background-color: #ffffff;padding-left: 5px;padding-right:5px;height: 100%;position: relative;">
            <el-table
                :data="tableData"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                border
                size="mini"
                height="calc(100% - 60px)"
                max-height="calc(100% - 60px)"
                style="width:100%;padding: 5px"
                @sort-change="roleSortChange"
                @selection-change="handleSelectionChange"
                :row-style="tableRowClassName"
                :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.4rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'6.5vh'}"
            >
              <template v-for="(item,index) in roleTitles">
                <template v-if="index ===0">
                  <el-table-column
                      :prop="item.prop"
                      :width="item.width"
                      :label="item.label"
                      :align="item.align"
                      :sortable="item.sortable"
                      show-overflow-tooltip
                      v-if="!item.isFilter">
                    <template slot-scope="scope">
                      <a style="cursor: pointer;color: #46adf5"
                         @click="roleFirstItemClickDeal(scope.row)">{{ scope.row.name }}</a>
                    </template>
                  </el-table-column>
                </template>
                <template v-else>
                  <el-table-column
                      :prop="item.prop"
                      :width="item.width"
                      :label="item.label"
                      :align="item.align"
                      :sortable="item.sortable"
                      show-overflow-tooltip
                  >
                  </el-table-column>
                </template>
              </template>
                <el-table-column label="操作" align="center"   width="200">
                    <template slot-scope="scope">
                        <el-tooltip content="删除" effect="light" >
                            <el-popconfirm style="margin-left: 10px" title="确定删除吗？"  @confirm="handleDelete(scope.row)">
                                <img src="~@/assets/images/operates/delete.png" alt="" slot="reference" style="cursor: pointer;"/>
                            </el-popconfirm>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div style="width:100%;position: absolute;bottom: 10px;">
              <pageFooter @current-change="handleCurrentChange" @size-change="handleSizeChange" :rForm="params"></pageFooter>
            </div>
            <role-open  :userDialog.sync="userdialog"  @reset="reset"></role-open>
          </div>
        </el-main>
    </el-container>
</template>

<script>
  import roleOpen from "./open/roleOpen.vue";
  import ElHeader from "../../../node_modules/element-ui/packages/header/src/main.vue";
  import QueryGather from "../../components/buttonGather/queryGather";
  import pageFooter from "@/components/pageFooter.vue";

  export default {
    name: "TabRole",
    components: {
      pageFooter,
        ElHeader,
        roleOpen,
      QueryGather},
    data() {
      return {
        authority: {},
        loading:false,
        stRemHeight: 0,
        curInputTip:'请输入名称查询',
        tableData: [],
        roleTitles: [
          {prop: 'name', label: '角色名称', align: 'center', sortable: true, isFilter: false,},
          {prop: 'no', label: '序号',  align: 'center', sortable: true, isFilter: false,},
        ],
        multiple: true,
        params: {
          name:"",
          total: 1,
          size: 20,
          current: 1,
        },
        multipleSelection: [],

        dialog:{
          title:"",
          formVisible:false,
          data:{},
          defaultTree:[],
        },

        userdialog:{
          title:"",
          formVisible:false,
          data:{},
          defaultTree:[],
        },
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        let authList = JSON.parse(localStorage.getItem("thirdAuthority"))['section'];
        this.authority.read = true;
        this.authority.del = true;
        this.authority.edit = true;
        this.authority.query = true;
      },
      roleFirstItemClickDeal(row){
        if(this.authority.edit){
          this.setRole(row,'角色信息');
        }else if(this.authority.read){
          this.setRole(null);
        }
      },
      roleSortChange(column){
        let params = {
          name:"",
          total: 1,
          size: 20,
          current: 1,
          sortCol: column.prop,
          order: column.order === "descending" ? 1 : 0,
        };
        this.params = {};
        this.params = params;
        this.getJsxxPage_();
      },
      tableRowClassName({row, rowIndex}) {
        return {
          height: '5.83vh',
        };
      },
        getJsxxPage_(params){
          if(typeof params !="undefined"){
            this.params.name = params.curInputValue;
          }
            this.params.current= 1;
            this.getJsxxPage();
        },
      getJsxxPage() {
        this.request.get("/rm-srole/v1/pageList", {params: this.params}).then(res => {
          if (res.ok) {
            this.tableData = res.data.records;
            this.params.total = res.data.total;
            this.params.size = res.data.size;
          }
        })
      },
      handleSizeChange(val) {
        this.params.size = val;
          this.params.current= 1;
        this.getJsxxPage();
      },
      handleCurrentChange(val) {
        this.params.current = val;
        this.getJsxxPage();
      },
      chongzhi(){
        this.params.name = "";
          this.params.total = 1;
          this.params.size= 20;
          this.params.current= 1;
        this.getJsxxPage();
      },
      //表单重置
      reset(){
        this.dialog.data = {}
        this.userdialog.data = {}
        this.getJsxxPage();
      },
      handleDelete(row){
        this.request.delete("/rm-srole/v1/"+row.id, {params: row.id}).then(res => {
          if (res.ok) {
            this.$message.success("删除成功");
              this.params.current= 1;
            this.getJsxxPage();
          }
        })
      },
      handleAllDelete(){
        let selection =[]
        for(let s of this.multipleSelection){
          selection.push(s.id)
        }
        this.request.delete("/rm-srole/v1/ids",{data:selection}).then(res => {
          if (res.ok) {
            this.$message.success("批量删除成功");
              this.params.current= 1;
            this.getJsxxPage();
          }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.multiple = !val.length;
      },
      setRole(scope,title) {
        if (!scope) {
          //新增
          this.request.get("/rm-smodule/v1/tree", {}).then(res => {
            this.dialog.data = {}
            this.dialog.data.list = res.data
            this.userdialog.data = JSON.parse(JSON.stringify(this.dialog.data))
          })
        }
        else {
          //修改
          this.request.get("/rm-srole/v1/"+scope.id).then(res => {
            this.dialog.data={};
            this.dialog.data.no = scope.no;
            this.dialog.data.id = scope.id;
            this.dialog.data.name = scope.name;
            this.dialog.data.list = res.data.moduleTreeList;
            this.userdialog.data = JSON.parse(JSON.stringify(this.dialog.data))
            //二级菜单isIndeterminate
            for(let i of this.userdialog.data.list){
              if(i.children.length === 0){
                i.isIndeterminate = false
              }else{
                let checklenth = 0
                let checkAll = true
                for (let ii of i.children){
                  if(ii.hasCheck){
                    checklenth++
                  }

                  let sunlenth = 0
                  for(let iii of ii.children){
                    if(iii.hasCheck){
                      sunlenth++
                    }
                  }
                  ii.isIndeterminate = sunlenth > 0 && sunlenth < ii.children.length;
                  checkAll = checkAll && ii.isIndeterminate
                }
                i.isIndeterminate = checklenth > 0 && checklenth < i.children.length && !checkAll;
              }
            }
          })
        }
        this.dialog.title = title
        this.dialog.formVisible = true;
        this.userdialog.title = title
        this.userdialog.formVisible = true;
      }
    },
    created() {
      this.getJsxxPage();
      let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
      this.stRemHeight = windowHeight  - 260;


    }
  }
</script>
<style scoped>
    ::v-deep .el-main {
      display: block;
      flex: 1;
      flex-basis: auto;
      overflow: auto;
      box-sizing: border-box;
      padding: 10px;
    }
</style>
